var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:['app-toggle', _vm.checked ? 'checked' : null, _vm.disabled ? 'disabled' : null]},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('change', $event.target.checked)}}}),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }